import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';
import { ApplyBoundEnum } from '@Policy/utils/types';
import { PolicyTypeEnum } from '@Policy/utils/constants';
import { getDefaultRiskAiFilter } from './cfg.exchange';

const cfg = {
  policySubType: 0,
  policyType: 22,

  tmFileblockings: {
    fbApplyBound: 1,
  },
  tmVirusscans: {
    vsApplyBound: 1,
    vsTextTagSubjectContent: 'Suspicious File:',
    vsWormsTrojansActionType: 109,
  },
  tmWebthreatprotections: {
    wtpApprovedHeaderList: '',
    wtpUrlcvEnabled: 1,
    wtpExtractAttachmentUrl: 1,
    wtpApplyBound: ApplyBoundEnum.all,
  },
  tmAntispamfilters: {
    asActionOthers: 221,
    asApplyBound: 1,
    asApprovedHeaderList: '',
    asSkipInternalSpamDetection: 0,
  },
  tmDdafilters: {},
};

export function getGmailInboundTemplateConfig(
  t: TFunction<'translation'>,
  featureShow: Record<string, boolean | number>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.tfWritingStyleToExpectedSenderFeedbackMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorMessage',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleAdministratorMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  const riskAi = getDefaultRiskAiFilter(
    t,
    PolicyTypeEnum.GmailInline,
    featureShow
  );
  merge(tempConfig, riskAi);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
